import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import AloneStage from '../stages/filters/AloneStage';
import { NoBaseStageParameters } from '../stages/filters/NoBaseStage';

export interface AloneParameters extends BlockParameters, NoBaseStageParameters {}

@AddMetadata({
    type: BlockKeys.Alone,
    name: 'No Alone',
    description:
        'Keeps the Sensor Points that have at least 1 adjacent neighbor out of the six possible adjacent ones (i.e. removes those that have none)',
})
class AloneBlock extends PipelineBlock<AloneParameters> {
    constructor(params: AloneParameters, id?: string) {
        super(params, id);
    }

    protected override defineStages() {
        return [new AloneStage()];
    }
}

export default AloneBlock;
